/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DepartementProjection } from './DepartementProjection';
import {
    DepartementProjectionFromJSON,
    DepartementProjectionFromJSONTyped,
    DepartementProjectionToJSON,
    DepartementProjectionToJSONTyped,
} from './DepartementProjection';
import type { UserWithoutNameProjection } from './UserWithoutNameProjection';
import {
    UserWithoutNameProjectionFromJSON,
    UserWithoutNameProjectionFromJSONTyped,
    UserWithoutNameProjectionToJSON,
    UserWithoutNameProjectionToJSONTyped,
} from './UserWithoutNameProjection';

/**
 * 
 * @export
 * @interface EmployeeUserProjection
 */
export interface EmployeeUserProjection {
    /**
     * 
     * @type {number}
     * @memberof EmployeeUserProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUserProjection
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUserProjection
     */
    jobTitle?: string;
    /**
     * 
     * @type {UserWithoutNameProjection}
     * @memberof EmployeeUserProjection
     */
    userId?: UserWithoutNameProjection | null;
    /**
     * 
     * @type {DepartementProjection}
     * @memberof EmployeeUserProjection
     */
    departmentId?: DepartementProjection | null;
}

/**
 * Check if a given object implements the EmployeeUserProjection interface.
 */
export function instanceOfEmployeeUserProjection(value: object): value is EmployeeUserProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function EmployeeUserProjectionFromJSON(json: any): EmployeeUserProjection {
    return EmployeeUserProjectionFromJSONTyped(json, false);
}

export function EmployeeUserProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeUserProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'jobTitle': json['job_title'] == null ? undefined : json['job_title'],
        'userId': json['user_id'] == null ? undefined : UserWithoutNameProjectionFromJSON(json['user_id']),
        'departmentId': json['department_id'] == null ? undefined : DepartementProjectionFromJSON(json['department_id']),
    };
}

export function EmployeeUserProjectionToJSON(json: any): EmployeeUserProjection {
    return EmployeeUserProjectionToJSONTyped(json, false);
}

export function EmployeeUserProjectionToJSONTyped(value?: EmployeeUserProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'job_title': value['jobTitle'],
        'user_id': UserWithoutNameProjectionToJSON(value['userId']),
        'department_id': DepartementProjectionToJSON(value['departmentId']),
    };
}

